import { createApp } from 'vue';
import App from './App.vue';

// Log that we got this far
console.log('[Vue 3 Test] main.ts loaded, creating app...');

try {
  const app = createApp(App);
  app.mount('#app');
  console.log('[Vue 3 Test] App mounted successfully!');
} catch (error) {
  console.error('[Vue 3 Test] Failed to mount app:', error);

  // Show error in the DOM for devices without dev tools
  const appEl = document.getElementById('app');
  if (appEl) {
    appEl.innerHTML = `
      <div class="card">
        <h2 style="color: #C62828;">Vue 3 Failed to Initialize</h2>
        <p>Error: ${error instanceof Error ? error.message : String(error)}</p>
        <pre style="text-align: left; overflow: auto; font-size: 10px;">${error instanceof Error ? error.stack : ''}</pre>
      </div>
    `;
  }
}
